import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import TitlePage from "./../../../../../common/TitlePage";
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginBottom: 20,
        borderRadius: 10,
        '&:not(:first-child)': {
            borderBottom: 0,
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(16),
        flexBasis: '66.66%',
        flexShrink: 0,
        paddingBottom: 10,
        // color:"#9e9e9e",
        // fontWeight:600
    },
    body: {
        color: "#858585",

    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.text.secondary,
    },
    container: {
        padding: "20px",
        // background: "#f2f4f6",
        borderRadius: 15,
        marginBottom: 90,
        [theme.breakpoints.down("md")]: {
            width: "95%",
            margin: "0 auto",
            marginBottom: 30,
            padding: "5px 10px"
        },

    },
    AccordionSummary: {
        '& p': {
            flexBasis: '95%'
        }
    }
}));

export default function ControlledAccordions({ data }) {

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={classes.container}>
            <div className={`${classes.root} container-md`}>

                {data.map((item, index) =>
                    <Accordion key={index} expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} style={{ borderBottom: '1px solid #0B1742' }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            className={classes['AccordionSummary']}
                        >
                            <Typography className={classes.heading}>{item.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ flexDirection: 'column' }}>
                            {
                                item.answer?.map((value, index) => {
                                    return (
                                        <Typography className={classes.body} key={index}>
                                            {value}
                                        </Typography>

                                    )
                                })
                            }
                        </AccordionDetails>
                    </Accordion>
                )}
            </div>
        </div>
    );
}
const FAQ = [
    {
        question: "حساب وکالتی بورس کالا چیست؟",
        answer: "حساب وکالتی نزد بانک مورد نظر به حساب معاملاتی مشتریانی که قصد خرید کالا در بورس کالا را داشته باشند وصل میشود. از طریق این حساب به کارگزاری وکالت داده می‌شود تا وجه مورد نیاز سفارش‌های خرید در بورس کالا را مستقیما در حساب بانکی مشتری و با اجازه مشتری مسدود کند.",
    },
    {
        question: "کدام بانک‌ها امکان افتتاح حساب وکالتی را دارند؟",
        answer: "درحال حاضر امکان افتتاح حساب وکالتی برعهده بانک‌های ملت، پاسارگاد، صنعت و معدن، توسعه صادرات، سپه، آینده، اقتصاد نوین، کشاورزی، صادرات ایران، شهر، سینا، سامان، ملی ایران، رفاه کارگران، تجارت، توسعه تعاون، گردشگری و پارسیان است.",
    },
    {
        question: "آیا حساب وکالتی برای معاملات آتی برای معاملات بورس کالا کافی است؟",
        answer: "برای معاملات آتی باید حساب در اختیار معرفی شود که با حساب وکالتی متفاوت است. حساب در اختیار باید در بانکی افتتاح شود که شخص حساب عادی دیگری نیز در آن بانک داشته باشد تا حساب در اختیار فرد به آن متصل شود بنابراین باید به بخش اعلام شماره حساب وکالتی و در اختیار در سامانه ایبیگو مراجعه و بانک‌های موجود را بررسی و فرم مربوط به آن را دریافت شود. بعد از افتتاح حساب وکالتی مجدد وارد سامانه ایبیگو شده و از قسمت اعلام شماره حساب وکالتی و در اختیار، حساب خود را معرفی کند.",
    },
    {
        question: "افرادی که کد بورسی دارند هم باید برای ثبت نام در بورس کالا دوباره سجام و کد بورسی بگیرند؟",
        answer: "برای خرید خودرو از بورس کالا، داشتن کد بورسی کافی نیست و باید کد معاملاتی بازار فیزیکی بورس کالا دریافت شود. لازم به ذکر است، در صورت تکمیل روند ثبت‌نام و احرازهویت در سامانه سجام، نیازی به ثبت‌نام مجدد نیست.",
    },
    {
        question: "تعیین قیمت نهایی خودرو در بورس کالا چگونه است؟",
        answer: "قیمت‌گذاری (قیمت پایه) توسط شورای رقابت و با درنظر گرفتن قیمت تمام شده تولید خودرو، مالیات و …. تعیین می‌گردد و قیمت نهایی (معامله شده در بورس کالا) خودرو براساس میزان تقاضا و همچنین قیمت ثبت‌شده از جانب سرمایه‌گذاران تعیین می‌شود.",
    },
    {
        question: "کشف قیمت در بورس کالا به چه صورت انجام میگیرد؟",
        answer: "در صورتی که تعداد عرضه از تقاضا بیش‌تر باشد، معاملات با قیمت پایه انجام خواهد شد. چنانچه تعداد تقاضا از حجم کالای عرضه‌شده بیش‌تر شود، معاملات به‌صورت مزایده انجام می‌پذیرد. لذا سفارشات ارسال شده با قیمت بالاتر در اولویت قرار خواهند گرفت. و در صورت ارسال قیمت مساوی، قیمتی که به لحاظ زمانی زودتر ارسال گردد در اولویت خواهد بود.",
    },
    {
        question: "هر فرد چه تعداد خودرو می‌تواند بخرد؟",
        answer: "در حال حاضر برای خرید خودرو هر کد ملی تنها امکان ثبت سفارش روی یکی از خودروهای موجود و به تعداد یک عدد را دارد. به عبارت دیگر اگر شخصی در عرضه‌های قبلی موفق به خرید خودروی سواری شده‌ باشد امکان ثبت سفارش نخواهد داشت.",
    },

]
